import { ColumnType } from 'antd/es/table';

export interface IImproveQscSummaryParams extends Paths.ImproveQscControllerGetSummary.QueryParameters {}
export interface IImproveQscSummaryModel extends Components.Schemas.CirQscScoreDto {}
export interface IImproveQscSummaryMetric extends Components.Schemas.CirQscMetricDto {}

export interface IImproveQscFindingsCollectionParams extends Paths.ImproveQscControllerGetFindings.QueryParameters {}
export interface IImproveQscFindingsCollection extends Components.Schemas.CirQscFindingsCollectionDto {}
export interface IImproveQscFinding extends Components.Schemas.CirQscFindingDto {
  key: any;
}

export interface IImproveQscStoreCardsCollectionParams
  extends Paths.ImproveQscControllerGetStoreCards.QueryParameters {}
export interface IImproveQscStoreCardsCollection extends Components.Schemas.CirQscStoreCardsCollectionDto {}
export interface IImproveQscStoreCard extends Components.Schemas.CirQscStoreCardDto {}
export interface IImproveQscStoreCardFinding {
  key: any;
  finding: string;
}

export const getImproveQscFindingsConfig = (): ColumnType<IImproveQscFinding>[] => {
  const records: ColumnType<IImproveQscFinding>[] = [
    {
      key: 'storeCode',
      dataIndex: 'storeCode',
      title: 'Store',
      width: 76,
    },
    {
      key: 'visits',
      dataIndex: 'visits',
      title: 'Visits',
      width: 60,
      onHeaderCell: () => ({
        className: 't-align-e',
      }),
      onCell: () => ({
        className: 't-align-e',
      }),
    },
    {
      key: 'finding',
      dataIndex: 'finding',
      title: 'Finding',
    },
  ];

  return records.map((record) => ({
    ...record,
    onHeaderCell: (column: ColumnType<IImproveQscFinding>, index?: number) => {
      const { className, ...rest } = record.onHeaderCell?.(column, index) ?? {};

      return {
        ...rest,
        style: { padding: '8px 8px' },
        className: `ff-regular fs-xxxs color-gray-1 ${className ?? ''}`.trim(),
      };
    },
    onCell: (row: IImproveQscFinding, index?: number) => {
      const { className, ...rest } = record.onCell?.(row, index) ?? {};

      return {
        ...rest,
        style: { padding: '8px 8px' },
        className: `ff-regular fs-xxs ${className ?? ''}`.trim(),
      };
    },
  }));
};

export const getImproveQscStoreCardFindingsConfig = (): ColumnType<IImproveQscStoreCardFinding>[] => {
  const records: ColumnType<IImproveQscStoreCardFinding>[] = [
    {
      key: 'key',
      dataIndex: 'key',
      title: '#',
      width: 50,
    },
    {
      key: 'finding',
      dataIndex: 'finding',
      title: 'Finding',
    },
  ];

  return records.map((record) => ({
    ...record,
    onHeaderCell: (column: ColumnType<IImproveQscStoreCardFinding>, index?: number) => {
      const { className, ...rest } = record.onHeaderCell?.(column, index) ?? {};

      return {
        ...rest,
        style: { padding: '8px 8px' },
        className: `ff-regular fs-xxxs color-gray-1 ${className ?? ''}`.trim(),
      };
    },
    onCell: (row: IImproveQscStoreCardFinding, index?: number) => {
      const { className, ...rest } = record.onCell?.(row, index) ?? {};

      return {
        ...rest,
        style: { padding: '8px 8px' },
        className: `ff-regular fs-xxs ${className ?? ''}`.trim(),
      };
    },
  }));
};
